import React, { useEffect } from 'react';
import Icon from '../ui/Icon';
import { useLanguage } from '../../contexts/LanguageContext';

// Commandes slash du bot (bot-discord/Commands) — à tenir à jour quand une commande change
const BOT_COMMANDS = [
    {
        name: '/nullos',
        key: 'nullos',
        usage: '/nullos saison:<saison>',
        description: 'Liste les membres du serveur Discord qui n\'ont participé à aucun combat (attaque, défense ou tempo) pendant la saison choisie, donc à 0 point.',
        access: 'Rôle spécial défini dans Configuration',
    },
    {
        name: '/mp',
        key: 'mp',
        usage: '/mp role:<rôle> message:<texte>',
        description: 'Envoie le message en privé à tous les membres qui ont le rôle choisi.',
        access: 'Administrateur Discord',
    },
    {
        name: '/potions recolte',
        key: 'potionsRecolte',
        usage: '/potions recolte zone:<Vortex|Crocuzko|Solar> cle:<clé>',
        description: 'Note une récolte, avec la clé utilisée (Vortex, Solar ou aucune).',
        access: 'Rôle « Gestionnaire BDA »',
    },
    {
        name: '/potions pose',
        key: 'potionsPose',
        usage: '/potions pose zone:<Vortex|Crocuzko|Solar> cle:<clé>',
        description: 'Note une pose : ajoute une potion au compteur du joueur.',
        access: 'Rôle « Gestionnaire BDA »',
    },
    {
        name: '/potions recap',
        key: 'potionsRecap',
        usage: '/potions recap',
        description: 'Affiche les potions et clés utilisées par chacun.',
        access: 'Rôle « Gestionnaire BDA »',
    },
    {
        name: '/potions clear',
        key: 'potionsClear',
        usage: '/potions clear utilisateur:<membre>',
        description: 'Remet à zéro les potions et clés d\'un membre.',
        access: 'Rôle « Gestionnaire BDA »',
    },
];

/**
 * Fenêtre listant les commandes Discord du bot.
 */
const BotCommandsModal = ({ onClose }) => {
    const { t } = useLanguage();
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    return (
        <div className="c2-modal-backdrop" role="presentation" onClick={onClose}>
            <div
                className="c2-card c2-modal dash-commands"
                role="dialog"
                aria-modal="true"
                aria-labelledby="dash-commands-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="c2-modal__head">
                    <h2 id="dash-commands-title">{t('botCommands.title', 'Commandes du bot')}</h2>
                    <button type="button" className="c2-icon-btn" onClick={onClose} aria-label={t('common.close', 'Fermer')}>
                        <Icon name="close" size={20} />
                    </button>
                </div>
                <p className="c2-muted">{t('botCommands.hint', 'À taper dans Discord, sur le serveur où se trouve le bot.')}</p>

                <ul className="dash-commands__list">
                    {BOT_COMMANDS.map(cmd => (
                        <li key={cmd.name} className="dash-commands__item">
                            <code className="dash-commands__usage">{cmd.usage}</code>
                            <p>{t(`botCommands.${cmd.key}.description`, cmd.description)}</p>
                            <span className="dash-commands__access">
                                <Icon name="lock" size={14} />
                                {t(`botCommands.${cmd.key}.access`, cmd.access)}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default BotCommandsModal;
